<template>
  <div class="breadcrumb">
    <!-- Header Start -->
    <!-- BredCrumb-Section -->
    <div class="bred_crumb">
      <div class="container">
        <!-- shape animation  -->
        <span class="banner_shape1">
          <img src="images/banner-shape1.png" alt="image" />
        </span>
        <span class="banner_shape2">
          <img src="images/banner-shape2.png" alt="image" />
        </span>
        <span class="banner_shape3">
          <img src="images/banner-shape3.png" alt="image" />
        </span>

        <div class="bred_text">
          <h1>{{ title }}</h1>
          <ul>
            <li><router-link to="/">Home</router-link></li>
            <li><span>»</span></li>
             <li v-for="(crumb, index) in breadcrumbs" :key="index">
              
              <router-link :to="crumb.to">{{ crumb.text }}</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

defineProps({
  title: {
    type: String,
    required: true
  },
 
  // Optional: breadcrumbs as array of { text, to? }
  breadcrumbs: {
    type: Array,
    default: () => []
  }
});



// export default {
//   name: "BreadCrumb",
//   props: {
//     valueFromParent: {
//       type: String, // Set the type of the prop
//       required: true, // Make the prop required
//     },
//   },
//   data() {
//     return {
//       currentPath: "",
//       parentValue: "",
//     };
//   },

//   methods: {
//     gotopage() {
//       window.scroll(0, 0);
//       this.$router.push(`${this.valueFromParent}`);
//     },
//   },
//   mounted() {
//     // Update currentPath when the component is mounted
//     this.currentPath = this.$route.name;
//     console.log(this.currentPath, "Page Name");
//     //let newName = this.currentPath.replace(/_/g, " ");
//     let newName = this.currentPath.replace(/([a-z])([A-Z])/g, '$1 $2');;
//     this.parentValue = newName;
//   },
//   watch: {
//     // Update currentPath whenever the route changes
//     $route(to, from) {
//       this.parentValue = to.path;
//     },
//   },
// };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.breadcrumb {
  background: #000000;
  margin-bottom: 0;
  padding: 0;
}
</style>
